var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"icon"},[_c('p',{},[_vm._v(_vm._s(_vm.percent)+"%")])])])}
var staticRenderFns = []

export { render, staticRenderFns }